// extracted by mini-css-extract-plugin
export var equalColumn = "_ff-0";